import { Brain } from 'lucide-react';
import { Card } from '@/components/ui/card';
import { Progress } from '@/components/ui/progress';
import { Profile } from '@/types/profile';
import { getBioCategoryFromScore } from '@/utils/bioCategories';
import { cn } from '@/lib/utils';

interface ProfileBioScoreCardProps {
  profile: Profile;
}

export function ProfileBioScoreCard({ profile }: ProfileBioScoreCardProps) {
  const bioScore = profile.bio_score;
  const category = bioScore ? getBioCategoryFromScore(bioScore) : null;

  if (bioScore === undefined || bioScore === null || !category) return null;

  return (
    <Card className="bg-white/5 border-white/10 p-4">
      <div className="flex justify-between items-center">
        <div className="flex items-center gap-2">
          <Brain className="h-4 w-4 text-purple-400" />
          <span className="text-sm font-medium text-white">Análise da Bio</span>
        </div>
        <div className="flex items-center gap-2">
          <span className="text-lg">{category.icon}</span>
          <span className={cn("text-sm font-bold", category.color)}>
            {category.level}
          </span>
          <span className="text-xs text-white/40">{bioScore}/100</span>
        </div>
      </div>
      <Progress 
        value={category.progressValue} 
        className="h-1.5 bg-white/10 mt-2"
      />
    </Card>
  );
}
